<sc-auth-page-wrapper
  [mainTitle]="mainTitle"
  [subtitle]="subtitle"
  [authAction]="authAction">
  <div auth-page-wrapper-content class="text-center">
    <img [src]="mailSentImage" alt="Email Enviado">
    <p *ngIf="showHelp" class="mb-1">¿No recibiste nada o el mail es incorrecto? Por favor, <a [href]="mailTo">contactate con nosotros</a></p>
  </div>
  <div auth-page-wrapper-footer>
    <sc-auth-actions class="footer-action" [authAction]="authAction"></sc-auth-actions>
    <sc-auth-legal-footer></sc-auth-legal-footer>
  </div>
</sc-auth-page-wrapper>
